export default __webpack_public_path__ + "static/media/Company Brochure copy.e16fc62f.pdf";